import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const removeAuthoringLegislation = api(async function removeAuthoringLegislation({ id }) {
    return mutate(
        gql`
            mutation RemoveAuthoringLegislation($id: String!) {
                removeAuthoringLegislation(id: $id)
            }
        `,
        { id },
        { returns: "removeAuthoringLegislation" }
    )
})
